var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelivery201({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.13,9.71a.2.2,0,0,0,0,.15l-.1.05h0V9.48l.33-.16h0v.18H9.36A.23.23,0,0,0,9.13,9.71Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.68,9.31l.05,0,.06,0s0,0,0,0v.16s0,0,0,0h0s0,0,0,0h0V9.42h0L9,9.49H9v.41H9L8.7,9.74l0,0V9.32Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.41,9.29l-.1.05-.24.12H9L8.92,9.4H9l.32-.17h0l.11.06Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.17,9.16,9,9.23l-.22.11h0l-.1-.05h0L9,9.11h0l.1.05Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.12,9.31H9.05a.2.2,0,0,0-.2.21.18.18,0,0,0,0,.13.2.2,0,0,0,.16.07.2.2,0,0,0,.21-.2A.22.22,0,0,0,9.12,9.31Zm0,.31,0-.08H9v.08h0L9,9.36h0l0,.12,0,.14Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.09,9.51H9l0-.07a.43.43,0,0,1,0,0h0s0,0,0,0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.25,4.3c0,.62,0,1.21,0,1.8a.63.63,0,0,0,.39.64.58.58,0,0,0,.64-.1L7,6.05l.69.56a.63.63,0,0,0,.72.12.62.62,0,0,0,.35-.63V4.31H12a1.24,1.24,0,0,1,1.35,1.36c0,2.51,0,5,0,7.55,0,.34-.09.44-.42.44H6a1.88,1.88,0,0,0-.76-1.81A1.75,1.75,0,0,0,4,11.49a1.86,1.86,0,0,0-1.67,2.12l0,0H.4a.3.3,0,0,1-.3-.31A.3.3,0,0,1,.4,13l.29,0V5.67A1.24,1.24,0,0,1,2.05,4.3h3.2Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.83,7.37h.69c0,.07,0,.14,0,.21V9.11a.93.93,0,0,0,1,1H18V12.7a.89.89,0,0,1-.48.82,2.26,2.26,0,0,1-.31.1,1.88,1.88,0,0,0-3.38-1.36Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.57,13.34A1.38,1.38,0,1,1,4.19,12,1.39,1.39,0,0,1,5.57,13.34Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.74,13.34A1.39,1.39,0,1,1,15.36,12,1.39,1.39,0,0,1,16.74,13.34Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.17,7.37a1,1,0,0,1,.76.28c.6.59,1.19,1.19,1.79,1.79l0,.06-.16,0H15.55c-.3,0-.39-.09-.39-.38,0-.54,0-1.07,0-1.61C15.16,7.48,15.17,7.43,15.17,7.37Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.89,6.17V4.31H8.14V6.15l-.63-.5a.65.65,0,0,0-1,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery201);
export default __webpack_public_path__ + "static/media/Delivery-2-01.026aac7e.svg";
export { ForwardRef as ReactComponent };